import React, { useEffect, useSyncExternalStore } from 'react';

/**
 * App-brede toast (DS-pill .notizy-toast) voor bevestigingen die een
 * paginawissel moeten overleven, zoals "Je account is gekoppeld" na de
 * koppelpagina. Eén melding tegelijk; een nieuwe vervangt de vorige.
 */
type Listener = () => void;

let message: string | null = null;
let serial = 0;
const listeners = new Set<Listener>();

const emit = () => listeners.forEach(listener => listener());

export const showAppToast = (text: string): void => {
    message = text;
    serial += 1;
    emit();
};

const dismiss = (expectedSerial: number) => {
    if (serial !== expectedSerial) return;
    message = null;
    emit();
};

const subscribe = (listener: Listener) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

const TOAST_DURATION_MS = 3000;

const AppToastHost: React.FC = () => {
    const current = useSyncExternalStore(subscribe, () => message, () => null);
    const currentSerial = useSyncExternalStore(subscribe, () => serial, () => 0);

    useEffect(() => {
        if (!current) return;
        const timer = setTimeout(() => dismiss(currentSerial), TOAST_DURATION_MS);
        return () => clearTimeout(timer);
    }, [current, currentSerial]);

    if (!current) return null;

    return (
        <div className="notizy-toast-host" role="status" aria-live="polite">
            <div className="notizy-toast notizy-toast--success">
                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                {current}
            </div>
        </div>
    );
};

export default AppToastHost;
